import Vue from "vue";

import {queryPaginationUsers, editUser} from "@/api";
//
export default {
  namespaced: true,

  state: {
    users: {},
    page: 1,
    limit: 50,
    sort: "-_id",
    searchString: "",
    type: null,
    partnerPercent: null,
    isFiltered: false,
    loading: true,
  },

  mutations: {
    setUsers(state, users) {
      state.users = users;
    },
    setPage(state, page) {
      state.page = page;
    },
    setSort(state, sort) {
      state.sort = sort;
    },
    setLimit(state, limit) {
      state.limit = limit;
    },
    setIsFiltered(state, isFiltered) {
      state.isFiltered = isFiltered;
    },
    setSearchString(state, searchString) {
      state.searchString = searchString;
    },
    setType(state, type) {
      state.type = type;
    },
    setPartnerPercent(state, partnerPercent) {
      state.partnerPercent = partnerPercent;
    },
    setLoading(state, loading) {
      state.loading = loading;
    }
  },

  actions: {
    async searchQueryBuilder(store) {
      if (!store.state.searchString && !store.state.type && !store.state.partnerPercent) {
        store.commit("setIsFiltered", false);
        return {};
      }

      const queryBuilders = [
        {
          state: "searchString",
          builder: () => {
            const q = {
              $or: [
                {
                  login: {
                    $regex: `.*${store.state["searchString"]}.*`,
                    $options: "i"
                  }
                },
                {
                  email: {
                    $regex: `.*${store.state["searchString"]}.*`,
                    $options: "i"
                  }
                }
              ]
            };
            if (
              store.state["searchString"].length === 12 ||
              store.state["searchString"].length === 24
            )
              q["$or"].push({ _id: store.state["searchString"] });
            return q;
          }
        },
        {
          state: "type",
          builder: () => {
            return {
              type: store.state["type"]
            };
          }
        },
        {
          state: "partnerPercent",
          builder: () => {
            return {
              partnerPercent: store.state["partnerPercent"]
            };
          }
        }
      ];
      const query = {
        $and: queryBuilders
          .filter(b => !!store.state[b.state])
          .map(b => b.builder())
      };

      store.commit("setIsFiltered", true);
      return query;
    },
    async queryPaginationUsers(store) {
      store.commit("setLoading", true);
      const resp = await queryPaginationUsers({
        page: store.state.page,
        limit: store.state.limit,
        sort: store.state.sort,
        query: await store.dispatch("searchQueryBuilder")
      });

      if (resp && resp.data.status) {
        store.commit("setUsers", resp.data.result);
        store.commit("setLoading", false);
        return resp.data.result;
      }
    },
    async goToPage(store, payload) {
      if (
        payload.page &&
        store.state.users.totalPages &&
        store.state.users.totalPages >= payload.page
      ) {
        store.commit("setPage", payload.page);
        await store.dispatch("queryPaginationUsers");
      }
    },
    async changeSorting(store, payload) {
      if (payload.sort !== undefined) {
        store.commit("setSort", payload.sort);
        await store.dispatch("queryPaginationUsers");
      }
    },
    async changeLimit(store, payload) {
      if (payload.limit !== undefined) {
        store.commit("setLimit", payload.limit);
        await store.dispatch("queryPaginationUsers");
      }
    },
    changeSearchString(store, payload) {
      if (payload.searchString !== undefined) {
        store.commit("setSearchString", payload.searchString);
      }
    },
    changeType(store, payload) {
      if (payload.type !== undefined) {
        store.commit("setType", payload.type);
      }
    },
    changePartnerPercent(store, payload) {
      if (payload.partnerPercent !== undefined) {
        store.commit("setPartnerPercent", payload.partnerPercent);
      }
    },
    async performSearch(store, payload) {
      store.commit("setPage", 1);
      await store.dispatch("queryPaginationUsers");
    },
    async resetSearch(store, payload) {
      store.commit("setSearchString", "");
      store.commit("setType", null);
      store.commit("setPartnerPercent", null);
      await store.dispatch("queryPaginationUsers");
    },
    editUser(store, { id, data }) {
      return editUser(id, data)
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/users.js